import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { SystemNotificationModel } from 'app/models/system-notification.model';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MembershipService } from 'app/core/services/membership.service';

@Injectable()
export class SystemNotificationsService {
    constructor(private http: HttpClient, private config: ConfigService, private membership_serivce:MembershipService ) {

    }

    public GetNotifications(): Observable<Array<SystemNotificationModel>> {
        if(this.membership_serivce.isValidToken()){
            return this.http.get<Array<SystemNotificationModel>>(this.config.getApiRoute('api/v3/common/notifications')).pipe(
                map(data => {
                    return data;
                }),
                catchError((err: HttpErrorResponse) => {
                    return throwError((err.error ?? err).message);
                })
            );
        }
        return of([]);
    }
}
